import React, { FC, ReactNode, useEffect } from 'react'
import classNames from 'classnames'
import Modal from 'react-modal'
import styles from './baseModal.module.scss'

export interface BaseModalProps {
  children?: ReactNode
  contentClassName?: string
  isOpen: boolean
  onRequestClose?: () => void
  shouldCloseOnOverlayClick?: boolean
}

// Set the app element for accessibility and proper rendering
if (typeof document !== 'undefined') {
  Modal.setAppElement('body')
}

export const BaseModal: FC<BaseModalProps> = ({
  children,
  contentClassName,
  isOpen,
  onRequestClose,
  shouldCloseOnOverlayClick = true,
}) => {
  // Ensure modal is rendered at body level to avoid zoom issues
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  return (
    <Modal
      className={classNames(styles.content, contentClassName)}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={styles.overlay}
      parentSelector={() => document.body}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      <div>{children}</div>
    </Modal>
  )
}
